import {Component, Input, OnInit} from '@angular/core';
import {Group} from "../../models/group";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {GroupService} from "../../services/group/group.service";
import {MessagesService} from "../../services/messages/messages.service";
import {CustomValidators} from "../../calsses/CustomValidators";

@Component({
    selector: 'app-group-modal',
    templateUrl: './group-modal.component.html',
    styleUrls: ['./group-modal.component.scss']
})
export class GroupModal implements OnInit {


    @Input() projectId: String;
    @Input() databaseId: String;
    @Input() group: Group;

    groupForm: FormGroup;
    groupFormIsSubmitted: boolean = false;

    constructor(
        public activeModal: NgbActiveModal,
        private formBuilder: FormBuilder,
        private groupService: GroupService,
        private messagesService: MessagesService,
    ) {
    }

    ngOnInit() {
        this.groupForm = this.formBuilder.group({
            name: [this.group ? this.group.name || '' : '', [Validators.required]],
            price: ['', [CustomValidators.priceValidator()]],
        });
    }

    submitGroupForm() {
        this.groupFormIsSubmitted = true;

        if (this.groupForm.invalid) return;

        this.group = new Group({
          name: this.groupForm.controls.name.value,
          price: this.groupForm.controls.price.value,
        });

        this.groupService.postGroup(this.projectId, this.databaseId, this.group)
            .subscribe(
                () => this.messagesService.successToast('Group created.'),
                err => this.messagesService.errorToast(err),
                () => this.activeModal.close(true)
            );
    }
}
